export const nameReg = /^(?:(?![\s]{2,})(?![\.]{2,})(?![-]{2,})[\u00c0-\u01ffa-zA-Z0-9-(),'\.\s`])*$/;
export const emailReg = /^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9]+([\._A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/;